import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import React from 'react'

const Size = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={6}>
    <TextField
      label="Size"
      fullWidth
      value={moduleValues?.['Size']}
      onChange={(e) =>
        setModuleValues((prev) => ({ ...prev, ['Size']: e.target.value }))
      }
      type="number"
    />
  </Grid>
)

export default Size
